var BASWebServices;
(function (BASWebServices) {
    'use strict';
    function audioPlayerIm($compile, $timeout, $sce) {
        var tpl = "";
        tpl += '<audio preload="auto" id="audioplayer" src={{SIGNAL}} controls onloadeddata="" type="audio/wav">';
        tpl += '</audio>';
        return {
            template: tpl,
            scope: true
        };
    }
    BASWebServices.audioPlayerIm = audioPlayerIm;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=audioPlayerIm.js.map